const PROD = false;
const PRE_PROD = false;
const UAT = true;// do not change this flag, if above both flags are false then app will connect to UAT
const PROD_BASE = {
    SELF_SURVEY_SERVICES: 'https://prod-selfsurveyservices.godigit.com/',
    COMMON_DATA_SERVICE: 'https://prod-commondataservice.godigit.com/',
}




const UAT_BASE = {
    COMMON_DATA_SERVICE: 'https://uat-commondataservice.godigit.com/',
    SELF_SURVEY_SERVICES: 'https://prod-selfsurveyservices.godigit.com/',


}
        

const PREPROD_BASE = {
    SELF_SURVEY_SERVICES: 'https://preprod-selfsurveyservices.godigit.com/',
    COMMON_DATA_SERVICE: 'https://preprod-commondataservice.godigit.com/',
}


const BASE_URL = PROD ? PROD_BASE : PRE_PROD ? PREPROD_BASE : UAT_BASE;

const INSTRUCTIONS_URL = BASE_URL.COMMON_DATA_SERVICE + 'CommonDataService/rest/survey/instructions/';
const SELFSURVEYSERVICE_DOCUMENT_URL = BASE_URL.SELF_SURVEY_SERVICES + 'SelfSurveyServices/document'
const AGENT_DATA = BASE_URL.COMMON_DATA_SERVICE + 'CommonDataService/rest/GetWebUsers';
const SURVEY_INSTRUCTIONS=BASE_URL.COMMON_DATA_SERVICE+'CommonDataService/rest/survey/instructions/'
const DOCUMENT_LAST=BASE_URL.SELF_SURVEY_SERVICES+'SelfSurveyServices/document/last'

export {
    INSTRUCTIONS_URL,
    SELFSURVEYSERVICE_DOCUMENT_URL,
    AGENT_DATA,
    SURVEY_INSTRUCTIONS,
    DOCUMENT_LAST
};
